module.exports = __webpack_public_path__ + "static/img/third2_1_8_active.3876f320.jpg";